module.exports = __webpack_public_path__ + "img/yape.78ecb82d.png";